import { TableColumn } from '../models/table-column.model';

/* -------------------------------------------------------------------------- */
/*                               ANCHOR modelos                               */
/* -------------------------------------------------------------------------- */

/** Fila de la tabla "área de la tienda que generó mala experiencia". */
export interface IAreaMencion {
  variable: string;
  menciones: number;
  /** Texto con dos decimales tal como lo pinta el original ("2.90"). */
  porcentaje: string;
  /** Mismo dato en número, para construir el histórico del modal. */
  porcentajeValor: number;
  historico: string;
}

/** Bloque de menciones asociado a una pregunta de la encuesta. */
export interface IDetalleArea {
  detractores: number;
  filas: Array<IAreaMencion>;
}

/* -------------------------------------------------------------------------- */
/*                              ANCHOR columnas                               */
/* -------------------------------------------------------------------------- */

/** En esta pantalla TODOS los <th> son teal (#019C91). */
export const COLUMNAS_AREA: Array<TableColumn> = [
  { key: 'variable',   title: 'VARIABLE',    headerStyle: 'teal', cellStyle: 'text' },
  { key: 'menciones',  title: 'MENCIONES #', headerStyle: 'teal', cellStyle: 'center' },
  { key: 'porcentaje', title: 'MENCIONES %', headerStyle: 'teal', cellStyle: 'center', suffix: ' %' },
  { key: 'historico',  title: 'HISTÓRICO',   headerStyle: 'teal', cellStyle: 'icon', icon: 'bi-bar-chart-line-fill', sortable: false },
];

/* -------------------------------------------------------------------------- */
/*                              ANCHOR preguntas                              */
/* -------------------------------------------------------------------------- */

/** Las 12 preguntas de la encuesta, en el orden del selector del original. */
export const PREGUNTAS_ENCUESTA: Array<string> = [
  'Encontré disponibilidad de producto',
  'Los precios me parecieron adecuados',
  'La atención del personal fue amable',
  'El tiempo de espera en caja fue adecuado',
  'La tienda estaba limpia y ordenada',
  'Encontré fácilmente lo que buscaba',
  'La calidad de los productos fue la esperada',
  'Las promociones fueron atractivas',
  'El personal resolvió mis dudas',
  'La experiencia en cremería fue satisfactoria',
  'Me sentí seguro dentro de la tienda',
  'El proceso de pago fue rápido y sencillo',
];

export const PREGUNTA_DEFAULT: string = PREGUNTAS_ENCUESTA[0];

/* -------------------------------------------------------------------------- */
/*                              ANCHOR menciones                              */
/* -------------------------------------------------------------------------- */

/** Las menciones de cada pregunta suman sus detractores, y el % sale de ahí. */
export const DETALLE_AREA_POR_PREGUNTA: Record<string, IDetalleArea> = {
  'Encontré disponibilidad de producto': {
    detractores: 512,
    filas: [
      { variable: 'Cremería',                 menciones: 86,   porcentaje: '16.80',  porcentajeValor: 16.8,   historico: '' },
      { variable: 'Huevo',                    menciones: 73,   porcentaje: '14.26',  porcentajeValor: 14.26,  historico: '' },
      { variable: 'Mostrador',                menciones: 100,  porcentaje: '19.53',  porcentajeValor: 19.53,  historico: '' },
      { variable: 'Pasillo de autoservicio',  menciones: 98,   porcentaje: '19.14',  porcentajeValor: 19.14,  historico: '' },
      { variable: 'Semillas',                 menciones: 53,   porcentaje: '10.35',  porcentajeValor: 10.35,  historico: '' },
      { variable: 'Otra',                     menciones: 102,  porcentaje: '19.92',  porcentajeValor: 19.92,  historico: '' },
    ],
  },

  'Los precios me parecieron adecuados': {
    detractores: 447,
    filas: [
      { variable: 'Cremería',                 menciones: 93,   porcentaje: '20.81',  porcentajeValor: 20.81,  historico: '' },
      { variable: 'Frutas y verduras',        menciones: 37,   porcentaje: '8.28',   porcentajeValor: 8.28,   historico: '' },
      { variable: 'Mostrador',                menciones: 94,   porcentaje: '21.03',  porcentajeValor: 21.03,  historico: '' },
      { variable: 'Pasillo de autoservicio',  menciones: 39,   porcentaje: '8.72',   porcentajeValor: 8.72,   historico: '' },
      { variable: 'Semillas',                 menciones: 96,   porcentaje: '21.48',  porcentajeValor: 21.48,  historico: '' },
      { variable: 'Otra',                     menciones: 88,   porcentaje: '19.69',  porcentajeValor: 19.69,  historico: '' },
    ],
  },

  'La atención del personal fue amable': {
    detractores: 418,
    filas: [
      { variable: 'Cajas',                    menciones: 59,   porcentaje: '14.11',  porcentajeValor: 14.11,  historico: '' },
      { variable: 'Cremería',                 menciones: 37,   porcentaje: '8.85',   porcentajeValor: 8.85,   historico: '' },
      { variable: 'Mostrador',                menciones: 108,  porcentaje: '25.84',  porcentajeValor: 25.84,  historico: '' },
      { variable: 'Pasillo de autoservicio',  menciones: 71,   porcentaje: '16.99',  porcentajeValor: 16.99,  historico: '' },
      { variable: 'Piso de venta',            menciones: 64,   porcentaje: '15.31',  porcentajeValor: 15.31,  historico: '' },
      { variable: 'Otra',                     menciones: 79,   porcentaje: '18.90',  porcentajeValor: 18.9,   historico: '' },
    ],
  },

  'El tiempo de espera en caja fue adecuado': {
    detractores: 366,
    filas: [
      { variable: 'Área de empaque',          menciones: 58,   porcentaje: '15.85',  porcentajeValor: 15.85,  historico: '' },
      { variable: 'Cajas',                    menciones: 40,   porcentaje: '10.93',  porcentajeValor: 10.93,  historico: '' },
      { variable: 'Cremería',                 menciones: 33,   porcentaje: '9.02',   porcentajeValor: 9.02,   historico: '' },
      { variable: 'Mostrador',                menciones: 80,   porcentaje: '21.86',  porcentajeValor: 21.86,  historico: '' },
      { variable: 'Pasillo de autoservicio',  menciones: 45,   porcentaje: '12.30',  porcentajeValor: 12.3,   historico: '' },
      { variable: 'Otra',                     menciones: 110,  porcentaje: '30.05',  porcentajeValor: 30.05,  historico: '' },
    ],
  },

  'La tienda estaba limpia y ordenada': {
    detractores: 321,
    filas: [
      { variable: 'Baños',                    menciones: 36,   porcentaje: '11.21',  porcentajeValor: 11.21,  historico: '' },
      { variable: 'Cremería',                 menciones: 77,   porcentaje: '23.99',  porcentajeValor: 23.99,  historico: '' },
      { variable: 'Estacionamiento',          menciones: 37,   porcentaje: '11.53',  porcentajeValor: 11.53,  historico: '' },
      { variable: 'Mostrador',                menciones: 50,   porcentaje: '15.58',  porcentajeValor: 15.58,  historico: '' },
      { variable: 'Pasillo de autoservicio',  menciones: 46,   porcentaje: '14.33',  porcentajeValor: 14.33,  historico: '' },
      { variable: 'Otra',                     menciones: 75,   porcentaje: '23.36',  porcentajeValor: 23.36,  historico: '' },
    ],
  },

  'Encontré fácilmente lo que buscaba': {
    detractores: 298,
    filas: [
      { variable: 'Cremería',                 menciones: 39,   porcentaje: '13.09',  porcentajeValor: 13.09,  historico: '' },
      { variable: 'Mostrador',                menciones: 47,   porcentaje: '15.77',  porcentajeValor: 15.77,  historico: '' },
      { variable: 'Pasillo de autoservicio',  menciones: 35,   porcentaje: '11.74',  porcentajeValor: 11.74,  historico: '' },
      { variable: 'Piso de venta',            menciones: 60,   porcentaje: '20.13',  porcentajeValor: 20.13,  historico: '' },
      { variable: 'Semillas',                 menciones: 52,   porcentaje: '17.45',  porcentajeValor: 17.45,  historico: '' },
      { variable: 'Otra',                     menciones: 65,   porcentaje: '21.81',  porcentajeValor: 21.81,  historico: '' },
    ],
  },

  'La calidad de los productos fue la esperada': {
    detractores: 341,
    filas: [
      { variable: 'Cremería',           menciones: 39,   porcentaje: '11.44',  porcentajeValor: 11.44,  historico: '' },
      { variable: 'Frutas y verduras',  menciones: 41,   porcentaje: '12.02',  porcentajeValor: 12.02,  historico: '' },
      { variable: 'Huevo',              menciones: 66,   porcentaje: '19.35',  porcentajeValor: 19.35,  historico: '' },
      { variable: 'Mostrador',          menciones: 66,   porcentaje: '19.35',  porcentajeValor: 19.35,  historico: '' },
      { variable: 'Semillas',           menciones: 37,   porcentaje: '10.85',  porcentajeValor: 10.85,  historico: '' },
      { variable: 'Otra',               menciones: 92,   porcentaje: '26.98',  porcentajeValor: 26.98,  historico: '' },
    ],
  },

  'Las promociones fueron atractivas': {
    detractores: 264,
    filas: [
      { variable: 'Cajas',                    menciones: 35,   porcentaje: '13.26',  porcentajeValor: 13.26,  historico: '' },
      { variable: 'Cremería',                 menciones: 42,   porcentaje: '15.91',  porcentajeValor: 15.91,  historico: '' },
      { variable: 'Pasillo de autoservicio',  menciones: 72,   porcentaje: '27.27',  porcentajeValor: 27.27,  historico: '' },
      { variable: 'Piso de venta',            menciones: 37,   porcentaje: '14.02',  porcentajeValor: 14.02,  historico: '' },
      { variable: 'Semillas',                 menciones: 30,   porcentaje: '11.36',  porcentajeValor: 11.36,  historico: '' },
      { variable: 'Otra',                     menciones: 48,   porcentaje: '18.18',  porcentajeValor: 18.18,  historico: '' },
    ],
  },

  'El personal resolvió mis dudas': {
    detractores: 237,
    filas: [
      { variable: 'Cajas',                    menciones: 24,   porcentaje: '10.13',  porcentajeValor: 10.13,  historico: '' },
      { variable: 'Cremería',                 menciones: 38,   porcentaje: '16.03',  porcentajeValor: 16.03,  historico: '' },
      { variable: 'Mostrador',                menciones: 46,   porcentaje: '19.41',  porcentajeValor: 19.41,  historico: '' },
      { variable: 'Pasillo de autoservicio',  menciones: 40,   porcentaje: '16.88',  porcentajeValor: 16.88,  historico: '' },
      { variable: 'Piso de venta',            menciones: 34,   porcentaje: '14.35',  porcentajeValor: 14.35,  historico: '' },
      { variable: 'Otra',                     menciones: 55,   porcentaje: '23.21',  porcentajeValor: 23.21,  historico: '' },
    ],
  },

  'La experiencia en cremería fue satisfactoria': {
    detractores: 209,
    filas: [
      { variable: 'Cremería',         menciones: 51,   porcentaje: '24.40',  porcentajeValor: 24.4,   historico: '' },
      { variable: 'Mostrador',        menciones: 32,   porcentaje: '15.31',  porcentajeValor: 15.31,  historico: '' },
      { variable: 'Piso de venta',    menciones: 25,   porcentaje: '11.96',  porcentajeValor: 11.96,  historico: '' },
      { variable: 'Área de empaque',  menciones: 22,   porcentaje: '10.53',  porcentajeValor: 10.53,  historico: '' },
      { variable: 'Cajas',            menciones: 45,   porcentaje: '21.53',  porcentajeValor: 21.53,  historico: '' },
      { variable: 'Otra',             menciones: 34,   porcentaje: '16.27',  porcentajeValor: 16.27,  historico: '' },
    ],
  },

  'Me sentí seguro dentro de la tienda': {
    detractores: 154,
    filas: [
      { variable: 'Baños',                    menciones: 40,   porcentaje: '25.97',  porcentajeValor: 25.97,  historico: '' },
      { variable: 'Estacionamiento',          menciones: 23,   porcentaje: '14.94',  porcentajeValor: 14.94,  historico: '' },
      { variable: 'Pasillo de autoservicio',  menciones: 29,   porcentaje: '18.83',  porcentajeValor: 18.83,  historico: '' },
      { variable: 'Piso de venta',            menciones: 13,   porcentaje: '8.44',   porcentajeValor: 8.44,   historico: '' },
      { variable: 'Cajas',                    menciones: 20,   porcentaje: '12.99',  porcentajeValor: 12.99,  historico: '' },
      { variable: 'Otra',                     menciones: 29,   porcentaje: '18.83',  porcentajeValor: 18.83,  historico: '' },
    ],
  },

  'El proceso de pago fue rápido y sencillo': {
    detractores: 283,
    filas: [
      { variable: 'Área de empaque',  menciones: 49,   porcentaje: '17.31',  porcentajeValor: 17.31,  historico: '' },
      { variable: 'Cajas',            menciones: 53,   porcentaje: '18.73',  porcentajeValor: 18.73,  historico: '' },
      { variable: 'Cremería',         menciones: 54,   porcentaje: '19.08',  porcentajeValor: 19.08,  historico: '' },
      { variable: 'Mostrador',        menciones: 28,   porcentaje: '9.89',   porcentajeValor: 9.89,   historico: '' },
      { variable: 'Piso de venta',    menciones: 31,   porcentaje: '10.95',  porcentajeValor: 10.95,  historico: '' },
      { variable: 'Otra',             menciones: 68,   porcentaje: '24.03',  porcentajeValor: 24.03,  historico: '' },
    ],
  },
};

/* -------------------------------------------------------------------------- */
/*                              ANCHOR histórico                              */
/* -------------------------------------------------------------------------- */

/** 19 meses del modal HISTÓRICO, igual que el resto del tablero. */
export const MESES_HISTORICO: Array<string> = [
  'Feb-25', 'Mar-25', 'Abr-25', 'May-25', 'Jun-25', 'Jul-25', 'Ago-25',
  'Sep-25', 'Oct-25', 'Nov-25', 'Dic-25', 'Ene-26', 'Feb-26', 'Mar-26',
  'Abr-26', 'May-26', 'Jun-26', 'Jul-26', 'Ago-26',
];

/**
 * Desviaciones (en puntos porcentuales) que se aplican al valor actual de una
 * fila para dibujar su serie histórica; el último mes siempre cae en el valor
 * real de la tabla.
 */
export const DESVIACION_HISTORICO: Array<number> = [
  -1.9, -0.1, -1.6, 2.8, -0.9, -3.3, -1.8, 2.7,
  -4.3, 3.2, 1.7, 0.2, -3.2, -2.2, -0.6, -4.0,
  -3.2, 2.2, 0,
];
